import React, { useState } from 'react';
import { Modal } from 'flowbite-react';

import ModalGreenButton from './ModalGreenButton';
import ModalRedButton from './ModalRedButton';
import Loading from './Loading';
import ErrorWrapper from './ErrorWrapper';

const ModalItemsDelete = ({isModalItemsDeleteOpen, setIsModalItemsDeleteOpen, setSuccessAlert, loading, deleteFunction, itemId, itemType}) => {
    const[error, setError] = useState({"error": false, "message": ""});

    const handleDeleteItem = async (itemId) => {
        const res = await deleteFunction(itemId, itemType);
        if(res.error){
            setError({"error": true, "message": res.response})
            setTimeout(() => {
                setError({"error": false, "message": ""});
            }, 3000);
        }else{
            setError({"error": false, "message": ""})
            setIsModalItemsDeleteOpen(false);
            setSuccessAlert("Registro eliminado correctamente")
            setTimeout(() => {
                setSuccessAlert(null)
            }, 3000);
        }
    }

    return (
        <Modal show={isModalItemsDeleteOpen} position="top-center">
            <div className='flex flex-col p-6 text-center'>
                <div className='mb-6'>
                    ¿Está seguro que desea eliminar el registro?
                </div>
                {error.error&&<ErrorWrapper error={error.message} />}
                <div className='mb-6 mx-auto w-[80%]'>
                    {loading ? <Loading isLoading={true} /> : <ModalRedButton onClick={() => {handleDeleteItem(itemId)}} text='Eliminar' />}
                </div>
                <div className='mx-auto w-[80%]'>
                    <ModalGreenButton onClick={() => setIsModalItemsDeleteOpen(false)} text='Cancelar' />
                </div>
            </div>
        </Modal>
    );
}

export default ModalItemsDelete;